import { Table as AntTable } from "antd";
import * as styles from "./table.module.scss";

export const Table = (props) => {
  return <AntTable className={styles.table} {...props} />;
};

Table.Summary = AntTable.Summary;
